<template>
  <div class="apiToolPage">
    <div class="content-box">
      <div class="content-body">
        <div class="page-title">充值工具</div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="充值类型:">
            <el-radio-group v-model="form.user_type" @change="userTypeChange">
              <el-radio :label=1>个人充值</el-radio>
              <el-radio :label=2>企业充值</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="手机号:" prop="reg_mobile" :rules="rules.reg_mobile">
            <el-input v-model="form.reg_mobile" style="width: 295px" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>

          <el-form-item label="金额:" prop="amount" class="nonce_str-item" :rules="rules.amount">
            <el-input v-model="form.amount" style="width: 295px" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"><i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
            </el-input>
          </el-form-item>

          <el-form-item label="余额:">
            <span v-model="balance" style="width: 295px">{{ balance }}    元</span>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit()">充值</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "walletToolPage",
  data() {
    let phoneCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (value && !this.$config.regCommon.phone.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    }
    return {
      tabsActive: "first",
      form: {
        user_type: 1,
        amount: 1000,
        money: '',
        reg_mobile: ''
      },
      balance: '',
      curEnv: '',
      is_sandbox: true,
      rules: {
        reg_mobile: [
          {required: true, validator: phoneCheck,trigger: 'blur'}
        ],
        amount: [
          {required: true, message: '请输入金额', trigger: 'blur'},
        ],
      }
    }
  },
  components: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
    },
    userTypeChange() {
      this.balance = ''
    },
    getPath() {
      let env = this.$config.env;
      if (env === 'prd') {
        return '/sandbox'
      }
      return ''
    },
    onSubmitCheck() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          throw ""
        }
      })
      if (this.form.amount <= 0) {
        throw ("单次充值金额至少1")
      }

      if (this.form.amount > 1000) {
        throw ("单次充值金额不能超过1000")
      }
    },
    onSubmit() {
      try {
        this.onSubmitCheck()
      } catch (e) {
        if (e !== '') {
          this.$message.error(e)
        }
        return
      }

      this.$axios.post(this.getPath() + "/ajax/wallet/recharge", {
            user_type: this.form.user_type,
            reg_mobile: this.form.reg_mobile,
            amount: this.form.amount * 100  //元换成分
          },
          {
            headers: {
              'from': 'open',   //标记来自于门户的请求
            },
          }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.balance = (res.data.data) / 100   //分换成元
          return
        }
      }).catch((e) => {
      }).finally(
      );
    },
  },
}
</script>

<style lang="scss">

.apiToolPage {
  min-width: 1180px;
  width: 60%;
  padding: 20px 20px 30px 20px;
  margin: 0 auto;


  .content-box {
    position: relative;
    min-height: 300px;
    margin-top: 25px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

    .content-body {
      padding: 0 0 0 0;
    }

    .el-form {
      padding: 5px 340px 10px 100px;
    }
  }
}


.access_token-item .el-form-item__label {
  margin-left: -7px;
}

.nonce_str-item .el-button {
  margin-left: 18px;
}

.timestamp-item .el-button {
  margin-left: 18px;
}

.request_body_data-item .el-textarea__inner {
  width: 900px;
  height: 260px;
}

.api-content-box {
  width: 100%;
  padding: 22px 25px 25px 270px;
  box-sizing: border-box;

  .part-title {
    width: 100%;
    line-height: 35px;
    color: #424456;
    font-size: 15px;
    padding-left: 2px;
    border-bottom: 1px solid #F2F2F2;
    font-weight: bold;
  }

  .part-content {
    width: 100%;
    padding: 15px 3px 20px 5px;
    box-sizing: border-box;
  }

  .json-box {
    padding: 15px;
    max-height: 520px;
    font-size: 13px;
    line-height: 15px;
    background: #F7F7F7;
    box-sizing: border-box;
    overflow: auto;
  }

  .info-row {
    color: #212121;
    font-size: 14px;
    line-height: 24px;

    .info-label {
      display: inline-block;
      width: 90px;
      vertical-align: top;
    }

    .info-value {
      display: inline-block;
      width: 600px;
      vertical-align: top;
      color: #666;
    }

    .info-tag {
      display: inline-block;
      width: 60px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      background: #E4E6F4;
      border-radius: 2px;
      transform: scale(.88);
      transform-origin: left;
      margin-right: -5px;
    }

    .tag-position-top {
      position: relative;
      top: -1px;
    }
  }


}

.textarea {
  width: 100%;
  min-height: 120px;
  max-height: 300px;
  margin-left: auto;
  margin-right: auto;
  padding: 3px;
  outline: 0;
  border: 1px solid #a0b3d6;
  font-size: 12px;
  line-height: 24px;
  word-wrap: break-word;
  overflow-x: hidden;
  overflow-y: auto;
  //border-color: rgba(82, 168, 236, 0.8);
  //box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 8px rgba(82, 168, 236, 0.6);
}

.jsoneditor-poweredBy {
  display: none;
}

div.jsoneditor {
  color: #1A1A1A;
  border: 1px solid #F16222;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 0;
  line-height: 100%;
}

div.jsoneditor-menu {
  width: 100%;
  height: 35px;
  padding: 2px;
  margin: 0;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: white;
  background-color: #F16222;
  border-bottom: 1px solid #F16222;
}


.signature-body {
  min-height: 200px;
  width: 927px;
  margin-left: 80px;
  margin-top: 20px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  color: #000000;
  background-color: #F0F0F0;

  .sign-title-A {
    padding: 22px 0 0 25px;
  }

  .sign-title-B {
    padding: 22px 0 0 35px;
  }

  .sign-content-A {
    margin: 0 0 0 15px;
  }

  .sign-content-B {
    margin: -21px 0 0 80px;
    word-break: normal;
    width: auto;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
  }

}

.api-content-box {
  width: 100%;
  padding: 22px 25px 25px 270px;
  box-sizing: border-box;

  .part-content {
    width: 100%;
    padding: 15px 3px 20px 5px;
    box-sizing: border-box;
  }
}

.response-body {
  min-height: 200px;
  width: 927px;
  margin-left: -2px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  color: #000000;
  background-color: #F0F0F0;

}

.codeView {
  margin: 20px -265px 0px 80px;
}

textarea.jsoneditor-text, .ace-jsoneditor {
  min-height: 200px
}


</style>


// WEBPACK FOOTER //
// src/components/help/wallet.vue